import React from 'react'

export const FilledDownSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7176 0.152344H1.27268C0.989394 0.152344 0.831213 0.396094 1.00665 0.5625L5.72908 5.025C5.86426 5.15273 6.12454 5.15273 6.26115 5.025L10.9836 0.5625C11.159 0.396094 11.0008 0.152344 10.7176 0.152344Z"
        fill="#3E4685"
      />
    </svg>
  )
}
